import { createType } from 'framework/utils/createType';

export const CommissionsTabTypes = createType('allCommissions', 'allPayouts', 'myCommissions', 'myPayouts');
export type CommissionsTabType = typeof CommissionsTabTypes[number];
